import { RadioGroupItem } from '@dreryk/react-components';

import { guardiansTranslationKeys } from '../../translations';

import { GuardianModalFormBean, StatutoryRepresentative } from './GuardianModal.types';

export const STATUTORY_REPRESENTATIVE_RADIO_ITEMS: RadioGroupItem<StatutoryRepresentative>[] = [
   {
      id: StatutoryRepresentative.YES,
      label: guardiansTranslationKeys.yes,
   },
   {
      id: StatutoryRepresentative.NO,
      label: guardiansTranslationKeys.no,
   },
];

export const GUARDIAN_FORM_INITIAL_VALUES: GuardianModalFormBean = {
   guardian: null,
   fullName: null,
   relationCode: 'MOTHER',
   statutoryRepresentative: StatutoryRepresentative.NO,
};
